export enum AuthenticationMutation {
  loading = 'showLoadingMutation',
  buttonLoading = 'showButtonLoadingMutation',
  component = 'changeComponentStateMutation',
  error = 'errorMutation',
  login = 'loginMutation',
  forgotPassword = 'forgotPasswordMutation',
  setPassword = 'setPasswordMutation',
  logout = 'logoutMutation',
  resetPassword = 'resetPasswordMutation',
  acceptTerms = 'acceptTermsMutation',
  tagMatch = 'tagMatchMutation',
  changePassword = 'changePasswordMutation',
  registerAdmin = 'registerAdminMutation',
  registerVeterinarian = 'registerVeterinarianMutation',
  authenticateOwner = 'authenticateOwnerMutation',
  requestChangeEmail = 'requestChangeEmailMutation',
  confirmChangeEmail = 'confirmChangeEmailMutation',
  customerLoginTokenRequestMutation = 'customerLoginTokenRequestMutation'
}

export enum VeterinarianMutation {
  showLoadingMutation = 'showLoadingMutation',
  showButtonLoadingMutation = 'showButtonLoadingMutation',
  showTableLoadingMutation = 'showTableLoadingMutation',
  errorMutation = 'errorMutation',
  setVeterinarianOfficesMutation = 'setVeterinarianOfficesMutation',
  setCurrentVeterinarianOfficeMutation = 'setCurrentVeterinarianOfficeMutation',
  setSelectedVeterinarianOfficeIdMutation = 'setSelectedVeterinarianOfficeIdMutation',
  setSelectedVeterinarianUserIdMutation = 'setSelectedVeterinarianUserIdMutation',
  setCurrentVeterinarianOfficeUsersMutation = 'setCurrentVeterinarianOfficeUsersMutation',
  resetStateMutation = 'resetStateMutation',
  resetVeterinarianOfficeUsers = 'resetVeterinarianOfficeUsersMutation',
  newVeterinarianOfficeMutation = 'newVeterinarianOfficeMutation'
}

export enum VeterinarianOfficeUsersMutations {
  showLoadingMutation = 'showLoadingMutation',
  showButtonLoadingMutation = 'showButtonLoadingMutation',
  errorMutation = 'errorMutation',
  setCurrentVeterinarianOfficeUserMutation = 'setCurrentVeterinarianOfficeUserMutation',
  setLockOrUnlockUserSuccessMutation = 'setLockOrUnlockUserSuccessMutation',
  resetStateMutation = 'resetStateMutation'
}

export enum CustomersMutations {
  showLoadingMutation = 'showLoadingMutation',
  showButtonLoadingMutation = 'showButtonLoadingMutation',
  errorMutation = 'errorMutation',
  errorLookupMutation = 'errorLookupMutation',
  setAllCustomersMutation = 'setAllCustomersMutation',
  resetStateMutation = 'resetStateMutation',
  setCurrentCustomerMutation = 'setCurrentCustomerMutation',
  setPublicCustomerMutation = 'setPublicCustomerMutation',
  clearCurrentCustomerMutation = 'clearCurrentCustomerMutation'
}

export enum AdminUserMutations {
  showLoadingMutation = 'showLoadingMutation',
  showTableLoadingMutation = 'showTableLoadingMutation',
  errorMutation = 'errorMutation',
  setAllAdminUserssMutation = 'setAllAdminUserssMutation',
  resetStateMutation = 'resetStateMutation',
  setCurrentAdminUserMutation = 'setCurrentAdminUserMutation',
  setLockOrUnlockAdminUserSuccessMutation = 'setLockOrUnlockAdminUserSuccessMutation'
}

export enum RegisteredTagMutations {
  showLoadingMutation = 'showLoadingMutation',
  showButtonLoadingMutation = 'showButtonLoadingMutation',
  showTableLoadingMutation = 'showTableLoadingMutation',
  errorMutation = 'errorMutation',
  resetStateMutation = 'resetStateMutation',
  setCurrentRegisteredTagMutation = 'setCurrentRegisteredTagMutation',
  setRegisteredTagsMutation = 'setRegisteredTagsMutation',
  setDoesTagExistsMutation = 'setDoesTagExistsMutation',
  resetCurrentTagMutation = 'resetCurrentTagMutation',
  orderDetailsMutation = 'orderDetailsMutation'
}

export enum ReportMutations {
  showReportDownloading = 'showReportDownloadingMutation',
  reportError = 'reportErrorMutation',
  reset = 'resetMutation'
}
